// styles/maintenance.ts
import { styled } from "@mui/system";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export const MainBox = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgb(0, 32, 53, 0.8)",
  borderRadius: 16,
  boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
  backdropFilter: "blur(5px)",
  border: "1px solid rgba(255, 255, 255, 0.3)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
});

export const SubBox = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "470px",
  height: "50%",
  minWidth: 300,
  borderRadius: 10,
  color: "white",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    margin: "0px 20px 0px 20px",
  },
}));
export const HeaderTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 900,
  fontSize: 24,
  marginBottom: 1,
  textAlign: "center",
  whiteSpace: "nowrap",
  margin: "0 10px",
  textTransform: "capitalize",
  zIndex: 10,
  [theme.breakpoints.down("sm")]: {
    whiteSpace: "wrap",
  },
}));

export const MaintenanceImage = styled("img")(({ theme }) => ({
  marginBottom: "30px",
  maxWidth: "100%",
  [theme.breakpoints.down("sm")]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));
export const ContentTypography = styled(Typography)({
  fontSize: 16,
  textAlign: "center",
  fontWeight: 700,
});
